import React, { Component } from "react";
import Label from "../../../../components/atoms/Label";
import LabelWithText from "../../../../components/molecules/LabelWithText";
import LabelWithBtn from "../../../../components/molecules/LabelWithBtn";
import { browserHistory } from "react-router";

export default ({ title, infoDocs, agreementDocs }) => {
	let col = { label: "col-md-3", text: "col-md-9" };
	return (
		<div>
			<Label value={title} className="label-menu" />
			<div>
				<LabelWithBtn label={"Mutasi Rekening per Semester Terakhir"} col={col} isDisabled={!infoDocs || !infoDocs.mutation} url={infoDocs && infoDocs.mutation && infoDocs.mutation.url} />
				<LabelWithBtn label={"Laporan Keuangan per Semester Terakhir"} col={col} isDisabled={!infoDocs || !infoDocs.financialStatement} url={infoDocs && infoDocs.financialStatement && infoDocs.financialStatement.url} />
				<LabelWithBtn label={"Perjanjian Pinjaman"} col={col} isDisabled={!agreementDocs || !agreementDocs.url} url={agreementDocs && agreementDocs.url && agreementDocs.url} />
			</div>
		</div>
	);
};
